import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Dashboard/Header";
import Footer from "../Dashboard/Footer";

function Layout() {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="sticky top-0 z-40">
        <Header
          isSideMenuOpen={isSideMenuOpen}
          setIsSideMenuOpen={setIsSideMenuOpen}
        />
      </div>

      <main
        className={`flex-grow transition-all duration-300 ease-in-out ${
          isSideMenuOpen ? "mr-[260px]" : "mr-0"
        }`}
      >
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;

// import React, { useEffect, useState } from "react";
// import { Outlet } from "react-router-dom";
// import Header from "../Dashboard/Header";
// import Footer from "../Dashboard/Footer";
// import UserMobileHeader from "../Dashboard/UserMobileHeader";

// function Layout() {
//   const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   // Optional: for handling location modal and dropdown globally if needed
//   const [showLocationModal, setShowLocationModal] = useState(false);
//   const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

//   // Dummy location to pass – you can replace with actual logic
//   const [currentLocation, setCurrentLocation] = useState({
//     city: "Delhi",
//     area: "Connaught Place",
//     state: "Delhi",
//   });

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div className="flex flex-col min-h-screen">
//       <div className="sticky top-0 z-40">
//         {isMobile ? (
//           <UserMobileHeader
//             currentLocation={currentLocation}
//             onLocationClick={() => setShowLocationModal(true)}
//             onMenuClick={() => setIsUserDropdownOpen(true)}
//           />
//         ) : (
//           <Header
//             isSideMenuOpen={isSideMenuOpen}
//             setIsSideMenuOpen={setIsSideMenuOpen}
//           />
//         )}
//       </div>

//       <main
//         className={`flex-grow transition-all duration-300 ease-in-out ${
//           isSideMenuOpen ? "mr-[260px]" : "mr-0"
//         }`}
//       >
//         <Outlet />
//       </main>

//       <Footer />
//     </div>
//   );
// }

// export default Layout;
